import Keyboard from "../../services/helpers/keyboard";

class InputsList {
    static init() {

        let lists = Array.from(document.querySelectorAll('[data-inputs-list]'));
        lists.forEach(list => new InputsList(list));
    }

    constructor(el) {
        this.element = el;
        this.originLabel = this.element.querySelector("[data-inputs-list-origin]").cloneNode(true);

        this._init();
    }

    get items() {
        return Array.from(this.element.querySelectorAll('.inputs-list__item'));
    }

    get lastItem() {
        return this.items[this.items.length - 1];
    }

    _init() {
        this.items.forEach(item => this._handleItem(item));
    }

    _createItem() {
        let newItem = this.originLabel.cloneNode(true);
        let input = newItem.querySelector('input');
        input.value = "";

        this._handleItem(newItem);

        return newItem;
    }

    _handleItem(item) {
        let input = item.querySelector('input');

        input.addEventListener("keydown", e => {
            let code = Keyboard.codes[Keyboard.getCode(e)];

            switch(code) {
                case "enter":
                    e.preventDefault();
                    let newItem = this._createItem();
                    this.element.insertBefore(newItem, item.nextElementSibling);
                    let newItemInput = newItem.querySelector('input');
                    newItemInput.stopFocusEvent = true;
                    newItemInput.focus();
                    newItemInput.stopFocusEvent = false;
                    break;
                case "backspace":
                    if (!input.value) {
                        e.preventDefault();
                        this._removeItem(item);
                    }
                    break;
                case "arrowUp":
                    this._toPreviousItem(item);
                    break;
                case "arrowDown":
                    this._toNextItem(item);
                    break;
            }
        });

        input.addEventListener("input", e => {
            this._onFocus(item);
        });
        input.addEventListener("focus", e => {
            if (input.stopFocusEvent) return;
            this._onFocus(item);
        });

        let deleteButton = item.querySelector("[data-remove]");
        if (deleteButton) {
            deleteButton.addEventListener("click", e => {
                this._removeItem(item);
            })
        }
    }

    _onFocus(item) {
        if (this.lastItem === item) {
            let newItem = this._createItem();
            this.element.appendChild(newItem);
            
        }
    }

    _getPreviousItem(item) {
        return item.previousElementSibling;
    }

    _getNextItem(item) {
        return item.nextElementSibling;
    }

    _getItemToFocusAfterRemove(item) {
        let prevItem = this._getPreviousItem(item);
        if (prevItem) return prevItem;

        let nextItem = this._getNextItem(item);
        return nextItem;
    }

    _removeItem(item) {
        let itemToFocus = this._getItemToFocusAfterRemove(item);

        if (!itemToFocus) {
            itemToFocus = this._createItem();
            this.element.appendChild(itemToFocus);
        }

        item.remove();

        let input =  itemToFocus.querySelector('input');

        input.stopFocusEvent = true;
        input.select();
        input.stopFocusEvent = false;
    }

    _toPreviousItem(item) {
        let prevItem = this._getPreviousItem(item);
        if (prevItem) prevItem.querySelector('input').select();
    }

    _toNextItem(item) {
        let nextItem = this._getNextItem(item);
        if (nextItem) nextItem.querySelector('input').select();
    }
}

export default InputsList;